import { render, staticRenderFns } from "./RealNamePopup.vue?vue&type=template&id=7f90d1de&scoped=true&"
import script from "./RealNamePopup.vue?vue&type=script&lang=js&"
export * from "./RealNamePopup.vue?vue&type=script&lang=js&"
import style0 from "./RealNamePopup.vue?vue&type=style&index=0&id=7f90d1de&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7f90d1de",
  null
  
)

export default component.exports